module.exports = "/call-frontend/img/login_hero_logo.73b9d640.png";